import type { LacunaDoAcervo } from '@titularis/api-client';

/**
 * O que falta, em uma frase - e como o conserto muda com ela (D-39).
 *
 * **A distinção não é cosmética.** Sem endereço, falta a **fonte inteira**, e o
 * conserto é importá-la; com endereço, a fonte está no acervo e faltou um
 * dispositivo dela, e o conserto é reimportá-la. Ler as duas do mesmo jeito
 * mandaria o administrador procurar no lugar errado.
 *
 * Fora do componente porque é regra, e não desenho: aqui ela é conferível sem
 * navegador, que é o que o ambiente de teste deste app oferece.
 */
export function comoLer(lacuna: Pick<LacunaDoAcervo, 'address' | 'comoSeCita'>): string {
  return lacuna.address ? `${lacuna.address} da ${lacuna.comoSeCita}` : lacuna.comoSeCita;
}

/**
 * Quantas questões esperam por esta lacuna.
 *
 * **Conta questões distintas, e não relatos.** A mesma questão pode ser
 * devolvida duas vezes pela mesma falta - um motor tentou, o item voltou, outro
 * tentou - e contar relatos faria o backlog dizer que duas questões estão
 * travadas quando é uma só. O `reportCount` continua existindo para medir
 * insistência; o que ordena o trabalho é quanta questão está parada.
 */
export function questoesTravadas(lacunas: Pick<LacunaDoAcervo, 'questoes'>[]): number {
  return new Set(lacunas.flatMap((l) => l.questoes)).size;
}
